import React from 'react';

import TBody from './tbody';

// Special memoized wrapper for our table body that we will use during column resizing
const MemoizedTBody = React.memo(
  TBody,
  (prev, next) =>
    prev.table.options.data === next.table.options.data &&
    prev.table.getState().columnPinning === next.table.getState().columnPinning,
) as typeof TBody;

export default MemoizedTBody;
